import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import * as actionTypes from './actionTypes';
import { snackActions } from '../../../sc-utilities/SnackBar';


// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'integrity-checks',
    pluginName: 'ADMIN',
    entityName: 'INTEGRITY_CHECK',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch IntegrityCheck action creators

export const fetchIntegrityCheckInit = () => { return crudActions.fetchInit(); }
export const fetchIntegrityCheckStart = () => { return crudActions.fetchStart(); }
export const fetchIntegrityCheckSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchIntegrityCheckFail = () => { return crudActions.fetchFail(); }

export const fetchIntegrityCheckCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchIntegrityCheckStart());
        try {
            let countRes = await rest.post("integrity-checks/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchIntegrityCheckSuccess(0, []));

                }
                return countRes.data.result.data
            }
            dispatch(fetchIntegrityCheckFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch integrity checks."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;

        } catch (error) {
            dispatch(fetchIntegrityCheckFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch integrity checks."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
};


export const fetchIntegrityCheck = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchIntegrityCheckStart());
        try {
            let listRes = await rest.post("integrity-checks/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchIntegrityCheckSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }

            dispatch(fetchIntegrityCheckFail());
            return []
        } catch (error) {
            dispatch(fetchIntegrityCheckFail());
            return []
        }
    }
};

const solveIntegrityCheckStart = () => {
    return {
        type: actionTypes.ADMIN_CHECK_START

    };
};

const solveIntegrityCheckSuccess = () => {
    return {
        type: actionTypes.ADMIN_CHECK_SUCCESS,
        status: true
    };
};

const solveIntegrityCheckFail = error => {
    return {
        type: actionTypes.ADMIN_CHECK_FAIL,
        error: error
    };
};


export const solveIntegrityCheck = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(solveIntegrityCheckStart());
        try {
            let res = await rest.post('/integrity-checks/update-status', data);
            if (res.data.succeeded) {
                dispatch(solveIntegrityCheckSuccess(data));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                });
            }
            else {
                dispatch(solveIntegrityCheckFail(res.error));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        }
        catch (err) {
            dispatch(solveIntegrityCheckFail(err));
            snackActions.snackBar({
                message: `${err}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
};
